import React from "react";
import { Row, Col } from "react-bootstrap";
import withBranding from "@irati/brand/withBranding";
import { getBrandLogo } from "@irati/utils/images/getImageSize/getImageSize";
import { BRAND_LOGO_DIMENSIONS } from "@irati/brand/constants/brand";
import { MainSection, MainSectionImage } from "./styled";
var UserOnboardingMain = function (props) {
    var businessLogoUrl = props.branding.businessLogoUrl;
    var imageUrl = getBrandLogo(businessLogoUrl, BRAND_LOGO_DIMENSIONS.width, BRAND_LOGO_DIMENSIONS.height);
    return (React.createElement(MainSection, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(MainSectionImage, { src: imageUrl })),
            React.createElement(Col, { xs: 12 }, props.children || null))));
};
export default withBranding(UserOnboardingMain);
